
import { SET_PUB_REVIEW_REFERE } from "../constants/ActionTypes";

const INIT_STATE = {
    itemReview:null,
    isReview: false,
    item:null,
    
};


export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case SET_PUB_REVIEW_REFERE: {
            return {
                ...state,
                item: action.payload.item,
                itemReview : action.payload.itemReview,
                isReview: action.payload.isReview,
                operating: action.payload.operating
            }
        }
        default:
            return state;
    }
}
